import { createColumnDate, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../utils/form";
import {
    createFieldDate,
    createFieldSelect,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";


export const callRedAccountType = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "RED_ACCOUNT_TYPE", value: searchQuery });
export const callUserCompany = ({ searchQuery }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "active" },
        { name: "isCeo", type: "Boolean", operator: "=", value: true }
    ];
    if (searchQuery) {
        where.push(
            { openBucket: true, name: "idCard", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", name: "fullNameTh", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "fullNameEn", type: "String", operator: "like", value: searchQuery }
        );
    }
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "idCard", "fullNameTh", "fullNameEn", "refPersonType.*"],
                page: 0,
                size: 1000,
                where,
                sort: [{ name: "idCard", type: "ASC" }],
            }
        })
        .then(page => page.data);
};

export const createColumns = () => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.userRedAccount.refUser"),
            dataIndex: "refUser.idCard",
            customRender: ({ record }) => <div>{record.refUser?.idCard} {record.refUser?.fullNameTh}</div>,
            inputProp: () => ({
                list: callUserCompany,
                renderLabel: ({ item }) => (<div>{item.idCard} {item.fullNameTh}</div>),
            }),
            align: "left",
            width: 400,
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.userRedAccount.refRedAccountType"),
            dataIndex: "refRedAccountType.value",
            inputProp: () => ({ list: callRedAccountType, optLabel: "value" }),
            align: "center",
            width: 150,
            search: { name: "refRedAccountType.id" }
        }),
        createColumnDate({
            title: () => i18n.global.t("model.userRedAccount.startDate"),
            dataIndex: "startDate",
            width: 120,
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.userRedAccount.endDate"),
            dataIndex: "endDate",
            width: 120,
            align: "center"
        }),
    ]
    return columns
}

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refUser`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userRedAccount.refUser"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refUser,
                            "onUpdate:value": value => (model.refUser = value),
                            disabled: viewOnly,
                            list: callUserCompany,
                            renderLabel: ({ item }) => (<div>{item.idCard} {item.fullNameTh}</div>),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.fullNameTh`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRedAccountType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 6 } }),
                label: () => i18n.global.t("model.userRedAccount.refRedAccountType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRedAccountType,
                            "onUpdate:value": value => (model.refRedAccountType = value),
                            disabled: viewOnly,
                            list: callRedAccountType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}startDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 6 } }),
                label: () => i18n.global.t("model.userRedAccount.startDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.startDate, "onUpdate:value": value => (model.startDate = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}endDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 6 } }),
                label: () => i18n.global.t("model.userRedAccount.endDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.endDate, "onUpdate:value": value => (model.endDate = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userRedAccount.remark"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.remark,
                            "onUpdate:value": value => (model.remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
}